import { jsx as _jsx } from "react/jsx-runtime";
import { HcTooltip } from '@hotmart-org-ca/cosmos-web/dist/react/hc-tooltip';
export function Tooltip({ text, children, className, disabled, position = 'top' }) {
    if (disabled) {
        return children;
    }
    return (_jsx(HcTooltip, { text: text, position: position, className: className, role: "tooltip", children: children }));
}
